import { adminApi } from "@/common/lib/adminApi";
import { queryClient } from "@/common/lib/queryClient";
import { useMutation, useQuery } from "@tanstack/react-query";

export type AdminMeResponse = { email: string };

export function useAdminMe() {
  return useQuery({
    queryKey: ["admin", "me"],
    queryFn: () => adminApi.get<AdminMeResponse>("/me"),
    retry: 0,
    staleTime: 60_000,
  });
}

export function useAdminLogin() {
  return useMutation<{ ok: true }, Error, { email: string; password: string }>({
    mutationFn: (input) => adminApi.post("/login", input),
  });
}

export function useAdminLogout() {
  return useMutation<{ ok: true }, Error, void>({
    mutationFn: () => adminApi.post("/logout"),
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: ["admin"] });
    },
  });
}
